module.exports = __webpack_public_path__ + "img/infographics_1.2ca26779.png";